import styled from 'styled-components'
// Style Component
export const BgSubscribeOurWrapper = styled.div``;
export const BgSubscribeOur = styled.div`
  width: 100%;
  padding: 25px 15px;
  background-color: #3b9612;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 20px;
  overflow: hidden;
  .subIcon {
    font-size: 35px;
  }
  @media screen and (max-width: 1200px) {
    padding: 15px;
    .subIcon {
      font-size: 30px;
    }
  }
  @media screen and (max-width: 768px) {
    display: block;
  }
`;

export const YoutubeSubscribe = styled.div`
  width: 25%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  font-style: bold;
  color: #fff;
  text-transform: uppercase;
  ${"" /* transform: translate(-50%, -50%); */}
  @media screen and (max-width: 1200px) {
    font-size: 25px;
  }
  @media screen and (max-width: 768px) {
    width: 100%;
  }
  .buttonSub {
    background: none;
    border: none;
    outline: none;
    color: #fff;
    transition: all 0.6s;
    &:active {
      color: orange;
    }
  }

  .buttonSub {
    animation: shake 1s infinite;
  }

  @keyframes shake {
    0% {
      transform: translate(1px, -2px) rotate(-1deg);
    }
    10% {
      transform: translate(-1px, 2px) rotate(-1deg);
    }
    20% {
      transform: translate(1px, 2px) rotate(0deg);
    }
    30% {
      transform: translate(3px, 2px) rotate(0deg);
    }
    40% {
      transform: translate(1px, -1px) rotate(1deg);
    }
    50% {
      transform: translate(-1px, -2px) rotate(-1deg);
    }
    60% {
      transform: translate(-3px, 1px) rotate(0deg);
    }
    70% {
      transform: translate(3px, 1px) rotate(-1deg);
    }
    80% {
      transform: translate(-1px, -1px) rotate(1deg);
    }
    90% {
      transform: translate(-3px, 0px) rotate(1deg);
    }
    100% {
      transform: translate(1px, 1px) rotate(0deg);
    }
  }
`;

export const EmailSubscribe = styled.div`
  width: 42%;
  display: flex;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: 1200px) {
    display: block;
  }
  @media screen and (max-width: 768px) {
    width: 100%;
  }
  .search {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .searchTerm {
    width: 80%;
    padding: 0px 20px;
    height: 40px;
    border-radius: 20px 0 0 20px;
    outline: none;
    border: none;
    color: #000;
    @media screen and (max-width: 768px) {
      width: 60%;
      margin: 10px 0;
    }
  }

  .searchTerm:focus {
    color: #000;
  }

  .searchButton {
    width: 120px;
    height: 40px;
    background: #fab70a;
    text-align: center;
    color: #fff;
    border-radius: 0 20px 20px 0;
    cursor: pointer;
    text-transform: uppercase;
    font-size: 16px;
    outline: none;
    border: none;
    &:active {
      background-color: blue;
    }
  }

  .newsletter {
    font-size: 25px;
    color: #fff;
    margin: 0 10px;
    text-align: center;
    @media screen and (max-width: 1200px) {
      font-size: 20px;
    }
  }
`;
export const TelegramSubscribe = styled.div`
  width: 33%;
  display: flex;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: 1200px) {
    display: block;
  }
  @media screen and (max-width: 768px) {
    width: 100%;
  }
  .text {
    font-size: 26px;
    color: #fff;
    @media screen and (max-width: 1200px) {
      font-size: 20px;
      text-align: center;
    }
  }
  .btnClick {
    outline: none;
    border: none;
    background-color: #049cfc;
    color: #fff;
    border-radius: 20px;
    padding: 5px;
    width: 150px;
    margin: 0 5px;
    font-size: 20px;
    &:active {
      background-color: yellow;
    }
    .teleIcon {
    }
    @media screen and (max-width: 1200px) {
      font-size: 15px;
      width: 120px;
      margin: 0 35%;
      .teleIcon {
        font-size: 30px;
      }
    }
    @media screen and (max-width: 768px) {
      margin: 0 40%;
    }
    @media screen and (max-width: 420px) {
      margin: 0 30%;
    }
  }
`;
///
